import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import type { ProjectsResponse, DetailedProjectResponse } from './types.tsx';

const MAX_PROJECTS = 5;
const VALID_PROJECT_TYPES: string[] = ['business', 'service_desk', 'software'];

export const getProjectsEndpointUrl = (): string => '/rest/api/2/project/search';

export const getProjectEndpointUrl = (): string => '/rest/api/2/project';

export const getProjectsForFilterUrl = (
	filter: string,
	detailed: boolean,
	requireBrowsePermission: boolean,
	requireEditPermission: boolean,
	maxResults: number = MAX_PROJECTS,
	projectType = '',
): string => {
	const urlSearchParams = new URLSearchParams();
	urlSearchParams.set('orderBy', 'NAME');
	urlSearchParams.set('startAt', '0');
	urlSearchParams.set('query', filter);
	urlSearchParams.set('maxResults', maxResults.toString());
	if (detailed) {
		urlSearchParams.set('expand', 'lead,issueTypes');
	}

	const actions = [];
	if (requireBrowsePermission) {
		actions.push('browse');
	}
	if (requireEditPermission) {
		actions.push('edit');
	}
	if (actions.length > 0) {
		urlSearchParams.set('action', actions.join(','));
	}

	if (VALID_PROJECT_TYPES.includes(projectType)) {
		urlSearchParams.set('typeKey', projectType);
	}

	const urlParams = `?${urlSearchParams.toString()}`;
	return `${getProjectsEndpointUrl()}${urlParams}`;
};

export const getProjectForId = (projectId: string): string =>
	`${getProjectEndpointUrl()}/${encodeURIComponent(projectId)}`;

export const getProjects = (
	filter = '',
	detailed = false,
	requireBrowsePermission = false,
	requireEditPermission = false,
	maxResults: number = MAX_PROJECTS,
	projectType = '',
): Promise<ProjectsResponse> =>
	fetchJson(
		getProjectsForFilterUrl(
			filter,
			detailed,
			requireBrowsePermission,
			requireEditPermission,
			maxResults,
			projectType,
		),
	);

export const getProject = (projectId = ''): Promise<DetailedProjectResponse> =>
	fetchJson(getProjectForId(projectId));
